/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

export const LOAD_CASH_BANK_DETAILS = `${url}/LOAD_CASH_BANK_DETAILS`;
export const LOAD_CASH_BANK_DETAILS_SUCCESS = `${url}/LOAD_CASH_BANK_DETAILS_SUCCESS`;
export const LOAD_CASH_BANK_DETAILS_ERROR = `${url}/LOAD_CASH_BANK_DETAILS_ERROR`;

export const LOAD_CASH_IN_HAND_TRANSACTION = `${url}/LOAD_CASH_IN_HAND_TRANSACTION`;
export const LOAD_CASH_IN_HAND_TRANSACTION_SUCCESS = `${url}/LOAD_CASH_IN_HAND_TRANSACTION_SUCCESS`;
export const LOAD_CASH_IN_HAND_TRANSACTION_ERROR = `${url}/LOAD_CASH_IN_HAND_TRANSACTION_ERROR`;

export const LOAD_CASH_IN_HAND_LIST = `${url}/LOAD_CASH_IN_HAND_LIST`;
export const LOAD_CASH_IN_HAND_LIST_SUCCESS = `${url}/LOAD_CASH_IN_HAND_LIST_SUCCESS`;
export const LOAD_CASH_IN_HAND_LIST_ERROR = `${url}/LOAD_CASH_IN_HAND_LIST_ERROR`;

export const LOAD_ACCOUNT_TRANSACTION_DETAILS = `${url}/LOAD_ACCOUNT_TRANSACTION_DETAILS`;
export const LOAD_ACCOUNT_TRANSACTION_DETAILS_SUCCESS = `${url}/LOAD_ACCOUNT_TRANSACTION_DETAILS_SUCCESS`;
export const LOAD_ACCOUNT_TRANSACTION_DETAILS_ERROR = `${url}/LOAD_ACCOUNT_TRANSACTION_DETAILS_ERROR`;

export const LOAD_CASH_BANK_TOTAL_LIST = `${url}/LOAD_CASH_BANK_TOTAL_LIST`;
export const LOAD_CASH_BANK_TOTAL_LIST_SUCCESS = `${url}/LOAD_CASH_BANK_TOTAL_LIST_SUCCESS`;
export const LOAD_CASH_BANK_TOTAL_LIST_ERROR = `${url}/LOAD_CASH_BANK_TOTAL_LIST_ERROR`;

export const LOAD_TOTAL_CASH_BANK_TRANSACTION = `${url}/LOAD_TOTAL_CASH_BANK_TRANSACTION`;
export const LOAD_TOTAL_CASH_BANK_TRANSACTION_SUCCESS = `${url}/LOAD_TOTAL_CASH_BANK_TRANSACTION_SUCCESS`;
export const LOAD_TOTAL_CASH_BANK_TRANSACTION_ERROR = `${url}/LOAD_TOTAL_CASH_BANK_TRANSACTION_ERROR`;

export const CREATE_CASH_BANK_DETAILS = `${url}/CREATE_CASH_BANK_DETAILS`;
export const CREATE_CASH_BANK_DETAILS_SUCCESS = `${url}/CREATE_CASH_BANK_DETAILS_SUCCESS`;
export const CREATE_CASH_BANK_DETAILS_ERROR = `${url}/CREATE_CASH_BANK_DETAILS_ERROR`;

//category

export const UPDATE_CASH_BANK_DETAILS = `${url}/UPDATE_CASH_BANK_DETAILS`;
export const UPDATE_CASH_BANK_DETAILS_SUCCESS = `${url}/UPDATE_CASH_BANK_DETAILS_SUCCESS`;
export const UPDATE_CASH_BANK_DETAILS_ERROR = `${url}/UPDATE_CASH_BANK_DETAILS_ERROR`;

export const DELETE_CASH_BANK_DETAILS = `${url}/DELETE_CASH_BANK_DETAILS`;
export const DELETE_CASH_BANK_DETAILS_SUCCESS = `${url}/DELETE_CASH_BANK_DETAILS_SUCCESS`;
export const DELETE_CASH_BANK_DETAILS_ERROR = `${url}/DELETE_CASH_BANK_DETAILS_ERROR`;

export const LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA = `${url}/LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA`;
export const LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA_SUCCESS`;
export const LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA_ERROR = `${url}/LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA_ERROR`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

const constants = {
  LOAD_CASH_BANK_DETAILS,
  LOAD_CASH_BANK_DETAILS_SUCCESS,
  LOAD_CASH_BANK_DETAILS_ERROR,
  LOAD_CASH_IN_HAND_TRANSACTION,
  LOAD_CASH_IN_HAND_TRANSACTION_SUCCESS,
  LOAD_CASH_IN_HAND_TRANSACTION_ERROR,

  LOAD_ACCOUNT_TRANSACTION_DETAILS,
  LOAD_ACCOUNT_TRANSACTION_DETAILS_SUCCESS,
  LOAD_ACCOUNT_TRANSACTION_DETAILS_ERROR,

  LOAD_CASH_BANK_TOTAL_LIST,
  LOAD_CASH_BANK_TOTAL_LIST_SUCCESS,
  LOAD_CASH_BANK_TOTAL_LIST_ERROR,
  LOAD_TOTAL_CASH_BANK_TRANSACTION,
  LOAD_TOTAL_CASH_BANK_TRANSACTION_SUCCESS,
  LOAD_TOTAL_CASH_BANK_TRANSACTION_ERROR,

  LOAD_CASH_IN_HAND_LIST,
  LOAD_CASH_IN_HAND_LIST_SUCCESS,
  LOAD_CASH_IN_HAND_LIST_ERROR,

  CREATE_CASH_BANK_DETAILS,
  CREATE_CASH_BANK_DETAILS_SUCCESS,
  CREATE_CASH_BANK_DETAILS_ERROR,

  UPDATE_CASH_BANK_DETAILS,
  UPDATE_CASH_BANK_DETAILS_SUCCESS,
  UPDATE_CASH_BANK_DETAILS_ERROR,

  DELETE_CASH_BANK_DETAILS,
  DELETE_CASH_BANK_DETAILS_SUCCESS,
  DELETE_CASH_BANK_DETAILS_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA,
  LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA_SUCCESS,
  LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA_ERROR,
};

export default constants;
